import axios from 'axios'

const { CancelToken } = axios
const cancelTokens = {}
const TOO_LONG = 30000 // 30 seconds is too long enough
export const EXTREMELY_LONG_REQUEST_DURATION = 55000 // 55 seconds

const api = axios.create({
  baseUrl: window.wbConfig.baseUrl,
  headers: {
    'X-Requested-With': 'XMLHttpRequest',
  },
})

// Cancel token keys are request URL without params
const cancelAndGenerateToken = (request) => {
  const token = CancelToken.source()
  const { url: tokenKey } = request

  // cancel previous request
  cancelTokens[tokenKey]
    && cancelTokens[tokenKey].cancel('Operation canceled due to new request.')

  // update token for new request
  cancelTokens[tokenKey] = token

  return token.token
}

// Request inteceptor for auto-cancel
api.interceptors.request.use((request) => {
  if (request.cancelable === true) {
    request.cancelToken = cancelAndGenerateToken(request)
  }

  // let's timeout requests that take too long
  if (!request.timeout) {
    request.timeout = TOO_LONG
  }

  return request
}, (error) => Promise.reject(error))

// Response inteceptor for auto-cancel
api.interceptors.response.use((response) => {
  const { url: tokenKey } = response.config

  cancelTokens[tokenKey]
    && delete cancelTokens[tokenKey]

  return response
}, (error) => Promise.reject(error))

export default api
